import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import CloseIconSVG from 'component/svgComponents/close'
import RadioGroup from '../RadioGroup'
import RadioButton from '../Radio'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList', 'requiresApproval']

class DepositSideFilterForm extends React.Component {
  static propTypes = {
    depositList: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
    setValueToField: PropTypes.func.isRequired,
    sideFilterVisible: PropTypes.bool.isRequired,
    submit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    btnDisabled: PropTypes.bool.isRequired,
    closeFilters: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
  }

  updateRadioValue = (value) => {
    this.props.setValueToField('requiresApproval', value)
  }

  render() {
    const {
      depositList,
      fields,
      setValueToField,
      sideFilterVisible,
      submit,
      translate,
      btnDisabled,
      closeFilters,
      values,
    } = this.props
    const renderOptions = (idDepositList, field, id) => {
      const renderOption = (deposit) => {
        const { idDeposit } = deposit
        const currentValue = values[field]
        const checked = idDepositList.some((depositId) => depositId === idDeposit)
        return (
          <div key={idDeposit} className='stock-transfer-options' onClick={() =>
            setValueToField(
              fields[field].input.name,
              checked
                ? currentValue.filter((i) => i !== idDeposit)
                : [...currentValue, idDeposit]
            )
          }>
          <label
            className='stock-transfer-label'
            style={{ display: 'block', margin: '.5rem auto', fontWeight: checked ? 'bold' : 'normal' }}
          >
            {deposit.idDeposit === "" ? translate(deposit.dsDeposit) : `${deposit.idDeposit} - ${translate(deposit.dsDeposit)}`}
          </label>
          <input checked={checked} className='margin-right stock-transfer-checkbox' type={"checkbox"} />
          </div>
        )
      }

      return (
        <>
          <strong style={{ display: 'block', margin: '1rem auto' }}>
            {id === 'source' ? 'Depósitos de origem' : 'Depósitos de destino'}
          </strong>
          {depositList.map(renderOption)}
        </>
      )
    }

    const resetFilter = () => {
      setValueToField('idSourceDepositList', [])
      setValueToField('idDestinationDepositList', [])
      setValueToField('requiresApproval', '')
    }
    
    const submiteValues = () => {
      submit(values)
      closeFilters()
    }

    const approvalOptions = [
      { label: 'Todos', value: '' },
      { label: 'Sim', value: 'true' },
      { label: 'Não', value: 'false' }
    ]
  
    return (
      <>
      <div style={{display: sideFilterVisible ? 'shown' : 'none'}} className='bg-filter' />
        <div style={{display: sideFilterVisible ? '' : 'none'}} className='right-filter-container'>
          <CloseIconSVG className="right-filter-svg" onClick={() => closeFilters()} />
          <h3 className='margin-bottom-triple'>
            <strong>{translate('mobile.filter')}</strong>
          </h3>

          {renderOptions(
            values.idSourceDepositList,
            'idSourceDepositList',
            'source'
          )}
          {renderOptions(
            values.idDestinationDepositList,
            'idDestinationDepositList',
            'destination'
          )}

          <strong style={{ display: 'block', margin: '1rem auto' }}>
            Solicita aprovação:
          </strong>
          <RadioGroup>
            {approvalOptions.map((option) => (
              <RadioButton
                key={option.value}
                checked={values.requiresApproval === option.value}
                onClick={() => this.updateRadioValue(option.value)}
                name="requiresApproval"
                label={option.label}
              />
            ))}
          </RadioGroup>

          <div style={{marginTop: '30px'}} className='flex flex-row gap-filters'>
            <button
              className={`btn btn-danger-outline  full-w`}
              onClick={resetFilter}>
              {translate('suggestions.cleanFilters')}
            </button>

            <button
              className={`btn btn-primary  full-w`}
              disabled={btnDisabled }
              onClick={submiteValues}
              >
                {translate('commonReport.filter')}
            </button>
          </div>
      </div>
    </>
    )
  }
}


export default Form({ fields: FIELDS })(DepositSideFilterForm)

export { DepositSideFilterForm }